/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"

import axios from "../../axios.js"

import router from '@/router'
import Vue from 'vue'

export default {

  // JWT
  loginJWT({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {

          // If there's user data in response
          if (response.data.userData) {


            // Set accessToken
            localStorage.setItem("accessToken", response.data.accessToken)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.userData, { root: true })

            // Set bearer token in axios
            commit("SET_BEARER", response.data.accessToken)

            // Navigate User to homepage
            //router.push(router.currentRoute.query.to || '/dashboard/analytics')
            router.push('/dashboard/analytics')

            resolve(response)
          } else {
            reject({ message: "نام کاربری یا رمز عبور صحیح نمی باشد" })
          }

        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({ message: "Password doesn't match. Please try again." })
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')

          // Update data in localStorage
          localStorage.setItem("accessToken", response.data.accessToken)
          commit('UPDATE_USER_INFO', response.data.userData, { root: true })

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  },
  // OTP
  SendOTPCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.SendOTPCode(payload.mobile)
        .then(response => {
          // If the response is success
          if (response.data.success) {
            resolve(response.data.result.token)
          } else {
            reject({ message: "نام کاربری یا رمز عبور صحیح نمی باشد" })
          }

        })
        .catch(error => { reject(error) })
    })
  },
  ConfirmOTPCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.ConfirmOTPCode(payload)
        .then(async response => {
          // If the response is success
          if (response.data.success) {

            // Set accessToken
            localStorage.setItem("accessToken", response.data.result.accessToken)
            localStorage.setItem("refreshToken", response.data.result.refreshToken)
            localStorage.setItem("pubKey", response.data.result.pubKey)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.result.accessToken

            // Set bearer token in axios
            commit("SET_BEARER", response.data.result.accessToken)

            Vue.prototype.$http = axios;
            const accessToken = parseJwt(response.data.result.accessToken)

            if (accessToken.role == 'Consumer')
            accessToken.role = ['Consumer', 'OnlyConsumer'];
            else if (Array.isArray(accessToken.role)
              && accessToken.role.find(x => x == 'Consumer')
              && !accessToken.role.find(x => x == 'Merchant')
            ) {
              accessToken.role.push('OnlyConsumer')
            }

            let userData = {
              displayName: "",
              about: "",
              photoURL: require("@/assets/images/portrait/small/avatar-s-5.jpg"),
              email: "admin@admin.com",
              userRole: accessToken.role,
              phoneNumber: null,
            }
            commit('UPDATE_USER_INFO', userData, { root: true })

            await jwt.getProfileData()
              .then(response => {
                try {
                  let userData = {
                    uid: response.data.result.userId,
                    displayName: response.data.result.firstname + ' ' + response.data.result.lastname,
                    photoURL: require("@/assets/images/portrait/small/avatar-s-5.jpg"),
                    email: "admin@admin.com",
                    //userRole: "Merchant",
                    phoneNumber: null,
                  }
                  commit('UPDATE_USER_INFO', userData, { root: true })

                }
                catch (er) { }
              })
              .catch(error => { reject(error) });

            resolve(response);
            // Navigate User to homepage
            //setTimeout(function(){ router.push(router.currentRoute.query.to || '/'); }, 1000);

            //router.push(router.currentRoute.query.to || '/');

            //router.push('/users');

          } else {
            reject({ message: "نام کاربری یا رمز عبور صحیح نمی باشد" })
          }

        })
        .catch(error => { reject(error) })
    })
  },
  setProfileData({ commit }) {
    jwt.getProfileData()
      .then(response => {
        try {
          let userData = {
            uid: response.data.result.userId,
            displayName: response.data.result.firstname + ' ' + response.data.result.lastname,
            photoURL: require("@/assets/images/portrait/small/avatar-s-5.jpg"),
            email: "admin@admin.com",
            //userRole: "Merchant",
            phoneNumber: null,
          }
          commit('UPDATE_USER_INFO', userData, { root: true })
        }
        catch (er) { }
      })
      .catch(error => { reject(error) });
  },
  Logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit("CLEAR_BEARER");

      // If JWT login
      if (localStorage.getItem("pubKey"))
        localStorage.removeItem("pubKey")
      if (localStorage.getItem("refreshToken"))
        localStorage.removeItem("refreshToken")
      if (localStorage.getItem("accessToken")) {
        localStorage.removeItem("accessToken")
      }
      // Change role on logout. Same value as initialRole of acj.js
      //this.$acl.change('admin')
      localStorage.removeItem('userInfo')

      router.app.$store.dispatch('updateUserRole', { userRole: {} });
    });
  },

}
function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};
